
/*
    This component renders all the meta tags of the onepage.
    It also accepts props to update the meta tags for the business page.
    This means that every business page will have unique meta tags of the enterprise
*/
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import React from "react";

const Meta = (meta) => {

    const { lang, translate } = useSelector(state => state.AdminReducer);
    let description = ""
    let name = meta.data.establishment_name
    return (
        <Helmet>
            <title>{name}</title>

            {/* Don"t keep cache */}
            <meta http-equiv="cache-control" content="no-cache" />
            <meta http-equiv="expires" content="0" />
            <meta http-equiv="pragma" content="no-cache" />

            {/* General meta tags */}
            <meta charSet="utf-8" />
            <meta name="url" content={window.location.href} />
            <meta name="robots" content="index,follow" />

            {/* Prevents Search engine (Google, Yahoo and MSN)  to display its own description taken from its directory, instead of you meta description. Using below tag would ensure that Search engine would display your meta description below search results and it would be useful to improve your CTR. */}
            <meta name="robots" content="noodp,noydir" />
            <meta name="language" content={lang} />
            <meta name="copyright" content="identityBuilding bv" />
            <meta name="category" content={"Onepage"} />
            <meta name="description" content={description} />
            <meta name="image" content={meta.data.logos.length > 0 ? meta.data.logos[0].logo : ""} />
            {/* Social media meta tags */}
            {/* https://ogp.me/ */}

            {/* General */}
            <meta name="og:title" content={name} />
            <meta name="og:description" content={description} />
            <meta name="og:image" content={meta.data.logos.length > 0 ? meta.data.logos[0].logo : ""} />

            {/* Address */}
            <meta name="og:latitude" content={meta.data.address.lat ? meta.data.address.lat : "0"} />
            <meta name="og:longitude" content={meta.data.address.long ? meta.data.address.long : "0"} />
            <meta name="og:street-address" content={meta.data.address.street ? meta.data.address.street : ""} />
            <meta name="og:locality" content={meta.data.address.municipality ? meta.data.address.municipality : ""} />
            {/* <meta name="og:region" content={translate("flemish_region")} /> */}
            <meta name="og:postal-code" content={meta.data.address.postal_code ? meta.data.address.postal_code : ""} />
            <meta name="og:country-name" content={translate("belgium")} />


            {/* Twitter related tags */}
            <meta name="twitter:card" content="product" />
            <meta name="twitter:site" content={window.location.href} />
            <meta name="twitter:title" content={name} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={meta.data.logos.length > 0 ? meta.data.logos[0].logo : ""} />

            {/* Favicon / icon related meta tags */}
            <link rel="apple-touch-icon" sizes="180x180" type="image/png" href='favicon.ico' />
            <link rel="icon" type="image/png" sizes="32x32" href='favicon.ico' />
            <link rel="icon" type="image/png" sizes="16x16" href='favicon.ico' />
            <link rel="shortcut icon" type="image/png" href='favicon.ico' />
            <link rel="shortcut icon" type="image/png" href='favicon.ico' />
            <meta name="msapplication-TileColor" content="#ffc40d" />
            <meta name="theme-color" content="#ffffff" />

        // </Helmet>
    );
}

export default Meta;
